import { BaseStep, BlockStep, CommandStep, InputStep, TriggerStep, Type, WaitStep, Step } from ".";
import { GroupStep as GroupStepSchema } from "~/lib/pipeline/schema";

export type GroupStep = BaseStep & {
  type: Type.Group;
  label: string;
  steps?: (CommandStep | TriggerStep | WaitStep | InputStep | BlockStep)[];
};

export function parseGroupStep(config: GroupStepSchema): GroupStep {
  return {
    uuid: "",
    type: Type.Group,
    label: config.label || "",
  };
}

export function isGroupStep(step: Step): step is GroupStep {
  return step.type === Type.Group;
}
